export { default } from './CognitiveScreeningModule';
